import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

const MarketingDashboardPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4">Dashboard Marketing</h2>
          <p>Analiza rendimiento, conversiones y ventas relacionadas.</p>
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default MarketingDashboardPage;
